import React, { useEffect, useState } from 'react';

const TwitchStatus = ({ username, handleLinkClick }) => {
  const [twitchStatus, setTwitchStatus] = useState({
    isOnline: false,
    checking: true,
  });
  const [previewLoaded, setPreviewLoaded] = useState(false);

  useEffect(() => {
    if (username && username.length > 0) {
      setTwitchStatus((prev) => ({ ...prev, checking: true }));
      fetch(
        `https://static-cdn.jtvnw.net/previews-ttv/live_user_${username}-440x248.jpg`
      )
        .then((response) => {
          if (response.redirected) {
            console.log('Image was redirected from', response.url);
            setPreviewLoaded(false);
            setTwitchStatus({
              isOnline: false,
              checking: false,
            });
          } else {
            setPreviewLoaded(true);
            setTwitchStatus({
              isOnline: true,
              checking: false,
            });
          }
        })
        .catch((error) => {
          setPreviewLoaded(false);
          setTwitchStatus({
            isOnline: false,
            checking: false,
          });
        });
    }
  }, [username]);

  const getStatusColor = (isOnline) => {
    if (isOnline === null) return 'gray'; // Unknown status
    return isOnline ? 'green' : 'red';
  };

  const getStatusText = (isOnline) => {
    if (isOnline === null) return 'Status Unknown';
    return isOnline ? 'Online' : 'Offline';
  };

  if (!username) return null;

  return (
    <>
      <div className='pill bg-opacity-50 bg-black dark:bg-opacity-50 dark:bg-black text-white rounded-full py-2 px-4 my-3'>
        <div className='flex items-center'>
          {twitchStatus.checking ? (
            <div className='flex items-center'>
              <div className='animate-pulse h-5 w-5 bg-gray-400 rounded-full'></div>
              <span className='ml-2'>Checking...</span>
            </div>
          ) : (
            <>
              <div
                className='h-5 w-5 rounded-full'
                style={{
                  backgroundColor: getStatusColor(twitchStatus.isOnline),
                }}
              ></div>
              <a
                href={`https://twitch.tv/${username}`}
                target='_blank'
                rel='noopener noreferrer'
                className='ml-2 font-bold'
                style={{ color: getStatusColor(twitchStatus.isOnline) }}
                onClick={handleLinkClick}
              >
                {getStatusText(twitchStatus.isOnline)}
              </a>
            </>
          )}
        </div>
      </div>

      {previewLoaded && (
        <div className='mb-4' onClick={handleLinkClick}>
          <a 
            href={`https://twitch.tv/${username}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={`https://static-cdn.jtvnw.net/previews-ttv/live_user_${username}-440x248.jpg`}
              alt={`Stream preview`}
              className='w-full rounded-md'
            />
          </a>
        </div>
      )}
    </>
  );
};

export default TwitchStatus;
